// extracted by mini-css-extract-plugin
module.exports = {"container":"Bg-z","timeTop":"Cg-z","timeCountdown":"Dg-z","cta":"Eg-z","disabled":"Fg-z","product":"Gg-z"};